/* eslint-disable import/prefer-default-export */
const JSONAPIDeserializer = require( 'jsonapi-serializer' ).Deserializer;

export const userNormalizeData = async ( responseData ) => {
  // first get what we can out of the serialized data
  const options = {
    keyForAttribute: 'camelCase',
  };

  const deserializedData = await new JSONAPIDeserializer( options ).deserialize( responseData );

  return deserializedData;
};
